/**
 * Service category section component for displaying and selecting services
 */

import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import type { DoplnkovaSluzba } from "../../types";

interface ServiceCategorySectionProps {
  title: string;
  services: DoplnkovaSluzba[];
  selectedIds: number[];
  onToggle: (serviceId: number) => void;
}

export function ServiceCategorySection({
  title,
  services,
  selectedIds,
  onToggle,
}: ServiceCategorySectionProps) {
  const activeServices = services.filter(s => s.aktivna);
  if (activeServices.length === 0) return null;

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-semibold">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {activeServices.map(service => {
          const isSelected = selectedIds.includes(service.id);
          return (
            <div
              key={service.id}
              className={`flex items-center justify-between p-3 border rounded-lg transition-colors ${
                isSelected ? "bg-primary/10 border-primary" : ""
              }`}
            >
              <div className="flex items-center space-x-3">
                <Checkbox
                  checked={isSelected}
                  onCheckedChange={() => onToggle(service.id)}
                  id={`service-${service.id}`}
                />
                <Label
                  htmlFor={`service-${service.id}`}
                  className="cursor-pointer"
                >
                  {service.nazov}
                </Label>
              </div>
              <Badge variant="secondary">
                {Number(service.cena).toFixed(2)} €
              </Badge>
            </div>
          );
        })}
      </div>
    </div>
  );
}
